import React from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const DrawerButtons = ({
    setShowPagesDrawer,
    setShowSettingsDrawer,
    showPagesDrawer,
    showSettingsDrawer,
}) => {
    return (
        <>
            <Box hidden={showPagesDrawer} sx={{ m: 1, position: 'absolute' }}>
                <IconButton onClick={() => setShowPagesDrawer(true)}>
                    <ChevronRightIcon fontSize="small" />
                </IconButton>
            </Box>
            <Box
                hidden={showSettingsDrawer}
                sx={{ m: 1, position: 'absolute', right: 0 }}
            >
                <IconButton onClick={() => setShowSettingsDrawer(true)}>
                    <ChevronLeftIcon fontSize="small" />
                </IconButton>
            </Box>
        </>
    );
};

DrawerButtons.propTypes = {
    setShowPagesDrawer: PropTypes.func,
    setShowSettingsDrawer: PropTypes.func,
    showPagesDrawer: PropTypes.bool,
    showSettingsDrawer: PropTypes.bool,
};

export default DrawerButtons;
